<template>
  <div
    style="position: absolute; top: 0; left: 0; right: 0; height: 45px"
    class="bg-primary"
  />
  <cc-tabs fixed-tabs>
    <template #tabs>
      <v-tab>Actions</v-tab>
      <v-tab>Statuses & Conditions</v-tab>
      <v-tab>Icon Guide</v-tab>
      <v-tab>Damage Tables</v-tab>
    </template>
    <v-window-item>
      <action-economy />
      <actions :is-modal="isModal" />
    </v-window-item>
    <v-window-item>
      <statuses :is-modal="isModal" />
    </v-window-item>
    <v-window-item>
      <icon-guide :is-modal="isModal" />
    </v-window-item>
    <v-window-item>
      <damage-tables :is-modal="isModal" />
    </v-window-item>
  </cc-tabs>
</template>

<script lang="ts">
  import ActionEconomy from './qr_pages/ActionEconomy.vue'
  import Actions from './qr_pages/Actions.vue'
  import DamageTables from './qr_pages/DamageTables.vue'
  import IconGuide from './qr_pages/IconGuide.vue'
  import Statuses from './qr_pages/Statuses.vue'

  export default {
    name: 'Reference',
    components: {
      ActionEconomy,
      DamageTables,
      Actions,
      Statuses,
      IconGuide,
    },
    props: {
      isModal: {
        type: Boolean,
      },
      preScroll: {
        type: String,
        default: '',
      },
    },
    mounted() {
      if (this.preScroll) {
        this.$nextTick(() => {
          const el = document.getElementById(this.preScroll)
          if (el) {
            el.scrollIntoView()
          }
        })
      }
    },
  }
</script>
